import React from 'react'
import './headerLogo.scss'

const HeaderLogo = ({logo}) => {
    return (
        <div className="logoContainer">
            <img className="img-fluid" alt="logo" src={logo}/>
        </div>
    )
}

export default HeaderLogo;
